import { render, staticRenderFns } from "./DetailedCourseCardHorizontal.vue?vue&type=template&id=00d9cd14&scoped=true&"
import script from "./DetailedCourseCardHorizontal.vue?vue&type=script&lang=js&"
export * from "./DetailedCourseCardHorizontal.vue?vue&type=script&lang=js&"
import style0 from "./DetailedCourseCardHorizontal.vue?vue&type=style&index=0&id=00d9cd14&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00d9cd14",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VFlex } from 'vuetify/lib/components/VGrid';
installComponents(component, {VFlex})
